var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C10.3431 3 9 4.34315 9 6V11C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11V6C15 4.34315 13.6569 3 12 3ZM13 19.9451V21.5C13 22.0523 12.5523 22.5 12 22.5C11.4477 22.5 11 22.0523 11 21.5V19.9451C6.50005 19.4476 3 15.6326 3 11C3 10.4477 3.44772 10 4 10C4.55228 10 5 10.4477 5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11C19 10.4477 19.4477 10 20 10C20.5523 10 21 10.4477 21 11C21 15.6326 17.5 19.4476 13 19.9451ZM12 1C14.7614 1 17 3.23858 17 6V11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11V6C7 3.23858 9.23858 1 12 1Z",
    fill: "#0D45DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicActive);
export default __webpack_public_path__ + "static/media/mic_active.2ae376dc172090143d460b6f72d63ce4.svg";
export { ForwardRef as ReactComponent };